import { type TooltipProps, Tooltip } from '@utima/ui';
import { memo } from 'react';

export interface SimpleTooltipProps extends TooltipProps {}

export const SimpleTooltip = memo(({ ...restProps }: SimpleTooltipProps) => (
  <Tooltip {...restProps} />
));
